/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';


/**
 * Task Queue Controller
 */
@Injectable({
  providedIn: 'root',
})
class TaskQueueControllerService extends __BaseService {
  static readonly processUserDefinitionPictureBackupTaskUsingGETPath = '/api/task/processUserDefinitionPictureBackupTask';
  static readonly processWordIndexingTaskUsingGETPath = '/api/task/processWordIndexingTask';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * processUserDefinitionPictureBackupTask
   * @param numTasks numTasks
   * @return OK
   */
  processUserDefinitionPictureBackupTaskUsingGETResponse(numTasks?: number): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (numTasks != null) __params = __params.set('numTasks', numTasks.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/task/processUserDefinitionPictureBackupTask`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * processUserDefinitionPictureBackupTask
   * @param numTasks numTasks
   * @return OK
   */
  processUserDefinitionPictureBackupTaskUsingGET(numTasks?: number): __Observable<{}> {
    return this.processUserDefinitionPictureBackupTaskUsingGETResponse(numTasks).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * processWordIndexingTask
   * @param numTasks numTasks
   * @return OK
   */
  processWordIndexingTaskUsingGETResponse(numTasks?: number): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (numTasks != null) __params = __params.set('numTasks', numTasks.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/task/processWordIndexingTask`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * processWordIndexingTask
   * @param numTasks numTasks
   * @return OK
   */
  processWordIndexingTaskUsingGET(numTasks?: number): __Observable<{}> {
    return this.processWordIndexingTaskUsingGETResponse(numTasks).pipe(
      __map(_r => _r.body as {})
    );
  }
}

module TaskQueueControllerService {
}

export { TaskQueueControllerService }
